module.exports = __webpack_public_path__ + "img/img.60ce7fe7.png";